import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setLanguage, setLanguageObj } from '../../redux/actions/commonActions'
import { languageObj } from '../../utils/common'
import './index.less'

const SelectLang = props => {
  const language = useSelector(state => state.commonStore.language)
  const dispatch = useDispatch()
  const changeLanguage = () => {
    let lang = language === 'zh_CN' ? 'en_US' : 'zh_CN'
    localStorage.setItem('language', lang)
    dispatch(setLanguage(lang))
    dispatch(setLanguageObj(languageObj[lang]))
  }
  let selClassZH = language === 'zh_CN' ? 'acss-1nbrequ acss-1n10ay4' : 'acss-1nbrequ acss-3ew1dt'
  let selClassEN = language === 'en_US' ? 'acss-1nbrequ acss-1n10ay4' : 'acss-1nbrequ acss-3ew1dt'
  return (
    <div className="nike_zoom acss-llcihc" onClick={() => changeLanguage()}>
      <span className={selClassZH}>中</span>
      <span className={selClassEN}>En</span>
    </div>
  )
}

export default SelectLang
